import { useMemo } from 'react';

import { Item } from '../types';
import { getCrumb } from '../utils';

/**
 * Génère le fil d'ariane à partir d'un produit ou d'une recette.
 *
 * Le chemin, renvoyé par le back, correspond à la position de l'élément dans le Catman.
 */
export const useBreadcrumbFromItem = (item: Item | null) => {
  const nativeCrumbs = useMemo(() => {
    const data = item?.breadcrumbs ?? [];
    return data.map(v => getCrumb('category', v));
  }, [item]);

  return nativeCrumbs;
};
